import { apiClient } from './client';
import { ClienteHistorico, Pedido, PedidoOrigem } from '../types';

export function listarPedidos(): Promise<Pedido[]> {
  return apiClient.get('/pedidos').then((res) => res.data.pedidos);
}

export function atualizarStatusPedido(id: number, status: Pedido['status']): Promise<Pedido> {
  return apiClient.put(`/pedidos/${id}/status`, { status }).then((res) => res.data.pedido);
}

export interface PedidoManualPayload {
  numero_pedido: string;
  nome_cliente: string;
  origem: PedidoOrigem;
  cep: string;
  logradouro: string;
  numero_endereco: string;
  complemento?: string;
  bairro: string;
  cidade: string;
  uf: string;
  observacoes?: string;
  motoboy_id?: number | null;
}

export function criarPedidoManual(payload: PedidoManualPayload): Promise<Pedido> {
  return apiClient.post('/pedidos/manual', payload).then((res) => res.data.pedido);
}

export function atribuirMotoboyPedido(id: number, motoboyId?: number | null): Promise<Pedido> {
  return apiClient.put(`/pedidos/${id}/motoboy`, { motoboy_id: motoboyId ?? null }).then((res) => res.data.pedido);
}

export function listarClientesHistorico(): Promise<ClienteHistorico[]> {
  return apiClient.get('/clientes').then((res) => res.data.clientes);
}

export interface ItemPedidoPublico {
  produto_id: number;
  quantidade: number;
}

export interface PedidoPublicoIdentificacao {
  telefone: string;
  nome: string;
  endereco?: {
    cep: string;
    logradouro: string;
    numero_endereco: string;
    complemento?: string;
    bairro: string;
    cidade: string;
    uf: string;
  };
}

export function fazerPedidoPublico(
  tenantId: string,
  identificacao: PedidoPublicoIdentificacao,
  itens: ItemPedidoPublico[]
): Promise<{ id: number; total: number; status: string }> {
  return apiClient
    .post(`/publico/pedidos/${tenantId}`, {
      cliente_telefone: identificacao.telefone,
      nome_cliente: identificacao.nome,
      ...(identificacao.endereco ?? {}),
      itens,
    })
    .then((res) => res.data.pedido);
}
